import { StockShareType } from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { BeneficiariesAllocationDto } from 'service/dto/general.dto';
import {
  AssignBeneficiaryDto,
  StockShare,
  StockShares
} from 'service/dto/stock-share.dto';
import { errorHandler } from 'utils';

class StockService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createStock = async (stockShareType: StockShareType) => {
    try {
      const response = await this.baseService.post(
        '/stock-share/create',
        stockShareType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getStocks = async (): Promise<StockShares> => {
    try {
      const response = await this.baseService.get('/stock-share');
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getStock = async (stockId: number): Promise<StockShare> => {
    try {
      const response = await this.baseService.get(`/stock-share/${stockId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteStock = async (stockId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(`/stock-share/${stockId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignBeneficiary = async (assignBeneficiaryDto: AssignBeneficiaryDto) => {
    try {
      const response = await this.baseService.patch(
        '/stock-share/assign-to-beneficiary',
        assignBeneficiaryDto
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  unAssignStockBeneficiary = async (allocationId?: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/stock-share/unassign-beneficiary/${allocationId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  editBulkStockBeneficiary = async (
    beneficiariesAllocationDto?: BeneficiariesAllocationDto
  ): Promise<void> => {
    try {
      const response = await this.baseService.patch(
        `/stock-share/bulk-edit-beneficiary-assign`,
        beneficiariesAllocationDto
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  removeStockTrustee = async (
    assetId: number,
    trusteeId: number
  ): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/stock-share/unassign-trustee/${assetId}/${trusteeId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignStockTrustee = async (
    assetId: number[],
    trusteeId: number,
    note: string
  ): Promise<void> => {
    try {
      const response = await this.baseService.put(
        `/stock-share/assign/bulk-trustee`,
        {
          assetId,
          trusteeId,
          note
        }
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default StockService;
